import { DocumentTranslationLanguage } from '@utils/types/shared.ts';

export const enumFallbackLanguages: Record<string, string> = Object.entries(
  DocumentTranslationLanguage
).reduce(
  (acc, [label, code]) => {
    acc[code.toLowerCase()] = label; // e.g., { ga: 'Irish' }
    return acc;
  },
  {} as Record<string, string>
);
